let vp = document.createElement("meta");
vp.name = "viewport";
vp.content = "width=device-width, initial-scale=1.0, maximum-scale=1.0, user-scalable=no";
document.head.appendChild(vp);
